import React from 'react'

import Base from '../_Base'

const ArrowForward = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M13.001 5v11.17l4.883-4.882a.997.997 0 0 1 1.41 0l.002.002.003.003a1 1 0 0 1-.003 1.412l-6.588 6.588a1 1 0 0 1-1.414 0l-6.588-6.588a.997.997 0 0 1 1.41-1.41l4.885 4.875V5a1 1 0 0 1 2 0z"
      fillRule="evenodd"
    />
  </Base>
)

export default ArrowForward
